var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullfillment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 7.625H4.3125C3.77344 7.625 3.375 8.04688 3.375 8.5625V14.375C3.375 14.5859 3.53906 14.75 3.75 14.75H4.125C4.3125 14.75 4.5 14.5859 4.5 14.375V13.25H12.75V14.375C12.75 14.5859 12.9141 14.75 13.125 14.75H13.5C13.6875 14.75 13.875 14.5859 13.875 14.375V8.5625C13.875 8.04688 13.4531 7.625 12.9375 7.625ZM12.75 12.5H4.5V11H12.75V12.5ZM12.75 10.25H4.5V8.75H12.75V10.25ZM15.1172 5.35156L9.23438 2.89062C8.83594 2.72656 8.39062 2.72656 7.99219 2.89062L2.10938 5.35156C1.5 5.58594 1.125 6.17188 1.125 6.82812V14.375C1.125 14.5859 1.28906 14.75 1.5 14.75H1.875C2.0625 14.75 2.25 14.5859 2.25 14.375V6.82812C2.25 6.61719 2.34375 6.45312 2.53125 6.38281L8.4375 3.92188C8.55469 3.875 8.67188 3.875 8.78906 3.92188L14.6953 6.38281C14.8828 6.45312 15 6.61719 15 6.82812V14.375C15 14.5859 15.1641 14.75 15.375 14.75H15.75C15.9375 14.75 16.125 14.5859 16.125 14.375V6.82812C16.125 6.17188 15.7266 5.58594 15.1172 5.35156Z",
    fill: "#737373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullfillment);
export default __webpack_public_path__ + "static/media/fullfillment.ee3190f7931b83d2c2bc798449cd3460.svg";
export { ForwardRef as ReactComponent };